/**
 * Created by admin on 2017/4/21.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import actions from './action';
import mutations from './mutations';
Vue.use(Vuex);
const state = {
    sysSid: "",
    sysSession: "",
    sysUserName: "",
    routerName: "",
    customerLevelList: [],
    customerSourceList: [],
    agentTypeList: [],
    AgentList: [], //园所管理的代理商列表
    ProjectTypeSignMateriel: {}, //物料
    allCity: [], //所有城市地址
    allProvince: [], //所有身份数据
    DescriptionList: [{
            key: 0,
            value: "试课",
            disabled: false
        },
        {
            key: 1,
            value: "正式",
            disabled: false
        },
        // {
        //     key: 2,
        //     value: "会销",
        //     disabled: false
        // }
    ],
    OutboundStatus: [{
            "TypeName": "-请选择-",
            "TypeValue": "-1"
        },
        {
            "TypeName": "待打单",
            "TypeValue": "1"
        },
        //{ "TypeName": "作废", "TypeValue": "3" },
        {
            "TypeName": "已打单",
            "TypeValue": "5"
        }
    ],
    // 用户等级
    LevelTypes: [{
            key: 1,
            value: "意向商"
        },
        {
            key: 2,
            value: "C级商"
        }, {
            key: 4,
            value: "B级商"
        }, {
            key: 8,
            value: "A级商"
        }
    ],
    //选择政策
    ChoicePolicyList: [{
            key: 1,
            value: "A政策"
        },
        {
            key: 2,
            value: "B政策"
        },
        {
            key: 4,
            value: "C政策"
        },
        {
            key: 32,
            value: "D政策"
        },
        {
            key: 64,
            value: "Q2地推政策"
        },
        {
            key: 512,
            value: "Q3政策"
        }
    ],
    orderStateMapList: [{
            id: -1,
            name: "请选择"
        },
        {
            id: 0,
            name: "待发货"
        },
        {
            id: 1,
            name: "部分发货"
        },
        {
            id: 2,
            name: "全部发货"
        },
        //{ id: 5, name: "已收货" }
    ],
    ContractStatusMap: [{
            id: 1,
            name: "寄出"
        },
        {
            id: 2,
            name: "收到"
        },
    ],
    PolicyType: [{
            name: "联帮在线",
            value: "1"
        },
        {
            name: "Hi幼教",
            value: "2",
            children: [{
                    name: "Hi幼教A",
                    value: "1"
                },
                {
                    name: "Hi幼教B",
                    value: "2"
                }
            ]
        }
        //{ name: "家庭一对一", value: "8" }
    ]
};

export default new Vuex.Store({
    state,
    actions,
    mutations
});


// WEBPACK FOOTER //
// ./src/vuex/index.js